import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IAddDocumentTemplateRequest, IDocumentListResponse, IDocumentPreview } from './documents-model';
import { IDocumentTemplate, IUpdateDocumentTemplate } from '@routes/templates/models/template-model';
import { IActivityLogs } from '../library-service/library-model';

@Injectable()
export class DocumentsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'documents';

    /** GET */
    public getDocumentTemplates(): Observable<SuccessResponse<IDocumentListResponse> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IDocumentListResponse>>(
                DocumentsService.URL +
                DocumentsService.ENDPOINT
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getDocumentTemplate(id: string): Observable<SuccessResponse<any> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<any>>(
                DocumentsService.URL +
                DocumentsService.ENDPOINT + '/' +
                id
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** POST */
    public addDocumentTemplate(document: IAddDocumentTemplateRequest): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(
                DocumentsService.URL +
                DocumentsService.ENDPOINT,
                document
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getPDFPreview(dataForPreview: any): Observable<SuccessResponse<IDocumentPreview> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IDocumentPreview>>(
                DocumentsService.URL +
                DocumentsService.ENDPOINT + '/' + 'preview',
                dataForPreview
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** PUT */
    public updateDocumentTemplate(document: IUpdateDocumentTemplate): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(
                DocumentsService.URL +
                DocumentsService.ENDPOINT + '/' +
                document.id,
                document
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public cloneDocumentTemplate(id: string, body: any): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(
                DocumentsService.URL +
                DocumentsService.ENDPOINT + '/' + id + '/clones', body).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getDocumentActivities(body: any): Observable<SuccessResponse<IActivityLogs> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(DocumentsService.URL +  DocumentsService.ENDPOINT + '/activities', body).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteDocumentTemplate(id: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(
                DocumentsService.URL +
                DocumentsService.ENDPOINT + '/' +
                id
                ).pipe(
            catchError(error => observableOf(new ErrorResponse(error?.error?.messages))));
    }

}
